import { useEffect, useState } from 'react';
import { FaSpinner, FaPlay, FaTimes, FaArrowLeft } from 'react-icons/fa';
import { getTutorials } from '../../service/serviceChat/tutorialService';
import { Avatar } from '../Avatar';
import * as S from './styled';

export function ArchivedTutorials({ userLogged }) {
    const [tutorials, setTutorials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedTutorial, setSelectedTutorial] = useState(null);

    useEffect(() => {
        async function fetchTutorials() {
            try {
                const data = await getTutorials();
                if (data && data.tutorials) {
                    setTutorials(data.tutorials);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }
        fetchTutorials();
    }, []);

    if (loading) {
        return (
            <S.Container>
                <S.LoadingContainer>
                    <FaSpinner size={44} color="#1D86FF" />
                    <span>Carregando tutoriais...</span>
                </S.LoadingContainer>
            </S.Container>
        );
    }
    const isVideo = (url) => {
        if (!url) return false;
        const lowerUrl = url.toLowerCase();
        return lowerUrl.includes('.mp4') || lowerUrl.includes('.mov') || lowerUrl.includes('.webm') || lowerUrl.includes('.ogg');
    };

    return (
        <S.Container>
            <S.TopBar>
                <S.HeaderContent>
                    <S.BackButton onClick={() => window.history.back()}>
                        <FaArrowLeft /> Voltar
                    </S.BackButton>
                    <S.Header>
                        <h1>Tutoriais e Documentos</h1>
                        <p>Aqui você pode revisar os tutoriais e documentos cadastrados no sistema.</p>
                    </S.Header>
                </S.HeaderContent>

                {(userLogged?.nomecompleto || userLogged?.nomeusuario) && (
                    <S.UserInfo>
                        {userLogged?.nomecompleto && (
                            <Avatar
                                name={userLogged.nomecompleto}
                                width="2.5rem"
                                height="2.5rem"
                                borderRadius="50%"
                                fontSize="1rem"
                            />
                        )}
                        <div className="user-details">
                            {userLogged?.nomecompleto && <span className="name">{userLogged.nomecompleto}</span>}
                            {userLogged?.nomeusuario && <span className="username">@{userLogged.nomeusuario}</span>}
                        </div>
                    </S.UserInfo>
                )}
            </S.TopBar>

            {tutorials.length > 0 && (
                <S.Grid>
                    {tutorials.map(tutorial => (
                        <S.Card key={tutorial.id} onClick={() => setSelectedTutorial(tutorial)}>
                            <div className="card-content">
                                <h3>{tutorial.title}</h3>
                                <p>{tutorial.description}</p>
                            </div>
                            <div className="card-action">
                                <FaPlay size={12} /> Visualizar
                            </div>
                        </S.Card>
                    ))}
                </S.Grid>
            )}

            {selectedTutorial && (
                <S.ModalOverlay onClick={() => setSelectedTutorial(null)}>
                    <S.ModalContent onClick={e => e.stopPropagation()}>
                        <S.CloseButton onClick={() => setSelectedTutorial(null)}>
                            <FaTimes />
                        </S.CloseButton>
                        <h2>{selectedTutorial.title}</h2>
                        <p className="description">{selectedTutorial.description}</p>
                        <S.MediaContainer>
                            {isVideo(selectedTutorial.url) ? (
                                <video
                                    src={selectedTutorial.url}
                                    title={selectedTutorial.title}
                                    width="100%"
                                    height="100%"
                                    controls
                                    autoPlay
                                />
                            ) : (
                                <iframe
                                    src={selectedTutorial.url}
                                    title={selectedTutorial.title}
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            )}
                        </S.MediaContainer>
                    </S.ModalContent>
                </S.ModalOverlay>
            )}
        </S.Container>
    );
}